/**
 * Constants and configuration for Analytics components
 * Only includes constants that are actually used in the codebase
 */

// Major label constants (used in dataTransformation.ts)
export const MAJOR_LABELS = ['UMG', 'SONY', 'WMG'] as const;
export type MajorLabel = (typeof MAJOR_LABELS)[number];
export type VendorCategory = MajorLabel | 'Indies' | 'UMG Music-Only';

// Vendor classification patterns (used in dataTransformation.ts)
export const VENDOR_PATTERNS = {
    UMG: ['universal'],
    SONY: ['sony'],
    WMG: ['warner']
};
// Chart colors for vendors (used in chart series functions)
export const VENDOR_COLORS = {
    UMG: '#1f77b4', // Blue
    SONY: '#ff7f0e', // Orange
    WMG: '#2ca02c', // Green
    Indies: '#d62728', // Red
    'UMG Music-Only': '#87CEEB' // Light blue
} as const;
